import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  yardSummaryModalIsOpen: false,
  isYardLegendsModalOpen: false,
  yardObjectsRawData: null,
  yardCapacityData: null
};

const yardSlice = createSlice({
  name: "yardSlice",
  initialState,
  reducers: {
    setYardSummaryModalIsOpen: (state, action) => {
      state.yardSummaryModalIsOpen = action.payload;
    },
    setIsYardLegendsModalOpen: (state, action) => {
      state.isYardLegendsModalOpen = action.payload;
    },
    setYardObjectsRawData: (state, action) => {
      state.yardObjectsRawData = action.payload;
    },
    setYardCapacityData: (state, action) => {
      state.yardCapacityData = action.payload;
    }
  }
});

export default yardSlice.reducer;

export const {
  setYardSummaryModalIsOpen,
  setIsYardLegendsModalOpen,
  setYardObjectsRawData,
  setYardCapacityData
} = yardSlice.actions;
